"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumCustomerPortalInternalTicketQuery = exports.SourgumCustomerPortalInternalTicketCreate = exports.SourgumCustomerPortalInternalTicketTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../common/enums");
exports.SourgumCustomerPortalInternalTicketTransport = typebox_1.Type.Recursive((Self) => typebox_1.Type.Object({
    note: typebox_1.Type.String(),
    status: typebox_1.Type.Optional(enums_1.InternalTicketStatus),
    replyToID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    images: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.PreSignedS3Object)),
    typedTags: typebox_1.Type.Array(enums_1.SourgumCustomerPortalTagType),
    isReply: typebox_1.Type.Boolean(),
    replies: typebox_1.Type.Array(Self), // Use Self to refer to the recursive type
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String({ format: 'date-time' }),
    }),
}), { $id: 'SourgumCustomerPortalInternalTicketTransport' });
exports.SourgumCustomerPortalInternalTicketCreate = typebox_1.Type.Object({
    entityID: typebox_1.Type.String({ minLength: 1 }),
    entityType: enums_1.SourgumInternalTicketRelatedEntity,
    note: typebox_1.Type.String(),
    images: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    typedTag: enums_1.SourgumCustomerPortalTagType,
});
exports.SourgumCustomerPortalInternalTicketQuery = typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        /**
         * Needs to be a comma separated list of entity ids. Use [].join(',')
         */
        entityID: typebox_1.Type.String({ minLength: 1 }),
    }),
]);
//# sourceMappingURL=internal-ticket.js.map